import { Component, ContentChild, Input, TemplateRef } from "@angular/core";
import { NotifyNewContentNames } from "src/app/components/ui/notify-new-content/notify-new-content.service";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";

@Component({
  selector: "snoots-page-detail-tab",
  template: "<ng-content></ng-content>",
  standalone: false
})
export class PageDetailTabComponent {
  @ContentChild("content")
  template: TemplateRef<Object> | undefined;

  @ContentChild(TemplateDirective)
  templateDirective: TemplateDirective | undefined;

  @Input()
  title: string = "";

  @Input()
  icon: string = "";

  @Input()
  disabled: boolean = false;

  @Input()
  badge: number | null = 0;

  @Input()
  name: string | undefined;

  @Input()
  notifyNewContentName: NotifyNewContentNames | undefined;

  @Input()
  payAttentionWarning: string | undefined;

  @Input()
  noContentPadding: boolean = false;
}
